import { module } from 'angular';
import { GmcDropdownMenuComponent } from './gmc-dropdown-menu.component';
import { gmcDropdownMenuItemDirective } from './directives';

export const GmcDropdownMenuModule = module('angular.share.components.gmc-dropdown-menu', [])
  .component('gmcDropdownMenu', GmcDropdownMenuComponent)
  .directive('gmcDropdownMenuItem', gmcDropdownMenuItemDirective);



// WEBPACK FOOTER //
// ./app/shared/components/gmc-dropdown-menu/gmc-dropdown-menu.module.ts